import { MONTHS } from "../constants";

export function buildSingaporePayslipHTML(employee, monthKey, data, ytdSgEarnings = 0) {
  const { rateLines, allowances, result } = data;
  const [year, monthNum] = monthKey.split("-");
  const monthName = MONTHS[parseInt(monthNum) - 1];
  const f = (n, d = 2) => Number(n || 0).toLocaleString("en-PG", { minimumFractionDigits: d, maximumFractionDigits: d });

  const currency = result.currency || "PGK";
  const fxRate = result.fxRate || 1;
  const isFx = currency !== "PGK";

  const validLines = rateLines.filter(l => parseFloat(l.sgRate || 0) > 0 && (l.rateMode === "monthly" || parseFloat(l.days) > 0));
  const sgTotalNative = validLines.reduce((s, l) => {
    const isMonthly = l.rateMode === "monthly";
    return s + (isMonthly ? parseFloat(l.sgRate) : parseFloat(l.days) * parseFloat(l.sgRate));
  }, 0);
  const sgTotalPGK = isFx ? sgTotalNative * fxRate : sgTotalNative;

  const earningRows = validLines.map(l => {
    const isMonthly = l.rateMode === "monthly";
    const rate = parseFloat(l.sgRate);
    const days = parseFloat(l.days);
    const totalNative = isMonthly ? rate : rate * days;
    const totalPGK = isFx ? totalNative * fxRate : totalNative;
    return `
    <tr>
      <td>${l.label}</td>
      <td class="muted">${isMonthly ? `Monthly rate: ${currency} ${f(rate)}` : `${l.days} days &times; ${currency} ${f(rate)}/day`}</td>
      <td class="right mono">${currency} ${f(isFx ? totalNative : totalPGK)}</td>
    </tr>`;
  }).join("");

  return `<!DOCTYPE html>
<html lang="en">
<head>
<meta charset="UTF-8"/>
<title>payslip_SG_${(employee.name || "Employee").replace(/\s+/g, "_")}_${monthName}_${year}</title>
<style>
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
  *{margin:0;padding:0;box-sizing:border-box}
  body{font-family:'Inter',Arial,sans-serif;font-size:11.5px;color:#212737;background:#fff}
  .page{width:210mm;min-height:297mm;margin:0 auto}
  .hdr{background:#384460;color:#fff;padding:20px 30px 16px;display:flex;justify-content:space-between;align-items:flex-end}
  .co-name{font-size:28px;font-weight:700;letter-spacing:-0.5px}
  .co-sub{font-size:9px;opacity:.75;margin-top:3px;letter-spacing:.1em;text-transform:uppercase}
  .ps-title{font-size:20px;font-weight:600;text-align:right}
  .ps-period{font-size:11px;opacity:.85;margin-top:2px;text-align:right}
  .info{background:#f8fafd;border-bottom:2px solid #384460;padding:14px 30px;display:grid;grid-template-columns:1fr 1fr;gap:20px}
  .lbl{font-size:8.5px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#8a8a9a;margin-bottom:2px}
  .val{font-size:13px;font-weight:600;color:#212737}
  .val-sm{font-size:11px;color:#384460;margin-top:1px}
  .body{padding:18px 30px}
  .sec-title{font-size:8.5px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:#384460;border-bottom:1px solid #e0e0e0;padding-bottom:4px;margin:16px 0 8px}
  table{width:100%;border-collapse:collapse}
  th{font-size:8.5px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;color:#8a8a9a;padding:5px 8px;text-align:left;background:#f8fafd}
  td{padding:6px 8px;border-bottom:1px solid #f2f2f2;color:#212737;vertical-align:top}
  tr:last-child td{border-bottom:none}
  .right{text-align:right}
  .mono{font-family:'Courier New',monospace;font-size:11px}
  .muted{color:#666;font-size:10px}
  .total-row td{font-weight:700;font-size:12px;background:#f0f2f8;border-top:2px solid #384460;border-bottom:none;color:#212737}
  .total-row .right{color:#384460}
  .summary{margin-top:16px;border:2px solid #384460;border-radius:5px;overflow:hidden}
  .summary-hdr{background:#384460;color:#fff;padding:7px 16px;font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase}
  .summary-grid{display:grid;grid-template-columns:repeat(2,1fr)}
  .sc{padding:10px 14px;border-right:1px solid #e0e0ef}
  .sc:last-child{border-right:none}
  .sc .l{font-size:8px;color:#8a8a9a;letter-spacing:.08em;text-transform:uppercase;font-weight:600;margin-bottom:3px}
  .sc .v{font-size:15px;font-weight:700;font-family:'Courier New',monospace}
  .ytd{margin-top:12px;background:#f8fafd;border:1px solid #e0e0e0;border-radius:5px;padding:10px 16px;display:flex;gap:40px}
  .ytd-item .l{font-size:8px;color:#8a8a9a;letter-spacing:.08em;text-transform:uppercase;font-weight:600;margin-bottom:2px}
  .ytd-item .v{font-size:13px;font-weight:700;font-family:'Courier New',monospace;color:#212737}
  .footer{margin-top:24px;padding:12px 30px;border-top:1px solid #e0e0e0;display:flex;justify-content:space-between;align-items:center}
  .footer-txt{font-size:8px;color:#aaa;line-height:1.6}
  .sig{width:150px;border-top:1px solid #ccc;text-align:center;padding-top:3px;font-size:8px;color:#aaa}
  @media print{
    body{-webkit-print-color-adjust:exact;print-color-adjust:exact}
    .page{margin:0;width:100%}
    @page{margin:0;size:A4 portrait}
  }
</style>
</head>
<body>
<div class="page">

<div class="hdr">
  <div>
    <div class="co-name">easy skill</div>
    <div class="co-sub">Singapore</div>
  </div>
  <div>
    <div class="ps-title">Pay Slip</div>
    <div class="ps-period">${monthName} ${year}</div>
  </div>
</div>

<div class="info">
  <div>
    <div class="lbl">Employee</div>
    <div class="val">${employee.name || "&mdash;"}</div>
    ${employee.position ? `<div class="val-sm">${employee.position}</div>` : ""}
  </div>
  <div style="text-align:right">
    <div class="lbl">Pay Period</div>
    <div class="val">${monthName} ${year}</div>
    <div style="margin-top:8px"><div class="lbl">Project</div><div class="val-sm">${employee.project || "&mdash;"}</div></div>
    <div style="margin-top:8px"><div class="lbl">Paying Entity</div><div class="val-sm">Easy Skill Pte. Ltd.</div></div>
  </div>
</div>

<div class="body">

  <div class="sec-title">Earnings</div>
  <table>
    <thead><tr><th>Rate Type</th><th>Detail</th><th class="right">Amount</th></tr></thead>
    <tbody>
      ${earningRows}
      <tr class="total-row">
        <td colspan="2">Total Earnings</td>
        <td class="right mono">${currency} ${f(isFx ? sgTotalNative : sgTotalPGK)}</td>
      </tr>
    </tbody>
  </table>

  ${(() => {
    const sgAllos = (allowances || []).filter(a => a.entity === "sg" && parseFloat(a.amount) > 0);
    const totalDays = validLines.reduce((s, l) => s + parseFloat(l.days), 0);
    const sgAlloTotal = sgAllos.reduce((s, a) => {
      const amt = parseFloat(a.amount) || 0;
      return s + (a.type === "per_diem" ? amt * totalDays : amt);
    }, 0);
    if (sgAllos.length === 0) return "";
    return `
  <div class="sec-title">Allowances &amp; Expenses</div>
  <table>
    <thead><tr><th>Description</th><th>Basis</th><th class="right">Amount (${currency})</th></tr></thead>
    <tbody>
      ${sgAllos.map(a => {
        const amt = parseFloat(a.amount) || 0;
        const total = a.type === "per_diem" ? amt * totalDays : amt;
        const displayAmt = isFx ? total / fxRate : total;
        return `<tr>
          <td>${a.label || (a.type === "expense" ? "Expense" : "Allowance")}</td>
          <td class="muted">${a.type === "per_diem" ? `${currency} ${f(isFx ? amt / fxRate : amt)} × ${totalDays} days` : a.type === "expense" ? "Expense reimbursement" : "Monthly fixed"}</td>
          <td class="right mono">${currency} ${f(displayAmt)}</td>
        </tr>`;
      }).join("")}
      <tr class="total-row">
        <td colspan="2">Total Allowances &amp; Expenses</td>
        <td class="right mono">${currency} ${f(isFx ? sgAlloTotal / fxRate : sgAlloTotal)}</td>
      </tr>
    </tbody>
  </table>`;
  })()}

  <div class="summary">
    <div class="summary-hdr">Pay Summary &mdash; ${monthName} ${year} &mdash; Singapore</div>
    <div class="summary-grid">
      <div class="sc"><div class="l">Earnings</div><div class="v" style="color:#384460">
        ${currency} ${f(isFx ? sgTotalNative : sgTotalPGK)}
      </div></div>
      <div class="sc"><div class="l">Total Paid</div><div class="v" style="color:#384460">
        ${(() => {
          const sgAllos2 = (allowances || []).filter(a => a.entity === "sg" && parseFloat(a.amount) > 0);
          const td2 = validLines.reduce((s, l) => s + parseFloat(l.days), 0);
          const at2 = sgAllos2.reduce((s, a) => { const amt = parseFloat(a.amount)||0; return s + (a.type === "per_diem" ? amt*td2 : amt); }, 0);
          return isFx ? `${currency} ${f(sgTotalNative + at2 / fxRate)}` : `PGK ${f(sgTotalPGK + at2)}`;
        })()}
      </div></div>
    </div>
  </div>

  <div class="sec-title">Year-to-Date &mdash; ${year} &mdash; Singapore</div>
  <div class="ytd">
    <div class="ytd-item"><div class="l">YTD SG Earnings</div><div class="v">${currency} ${f(isFx ? (ytdSgEarnings + sgTotalPGK) / fxRate : ytdSgEarnings + sgTotalPGK)}</div></div>
  </div>

</div>

<div class="footer">
  <div class="footer-txt">
    This is a computer-generated payslip and does not require a signature.<br/>
    Easy Skill Singapore &middot; www.easy-skill.com
  </div>
  <div class="sig">Authorised Signatory</div>
</div>

</div>
</body>
</html>`;
}
